import { Session } from "@/tools/msa/models";
import { compareNullableDates } from "@/tools/msa/utils/comparator";

export const sortDocumentsByDate = (session: Session) => {
  session.documents = session.documents
    .sort((a, b) => compareNullableDates(a.date, b.date))
    .map((document, index) => {
      document.index = index;
      return document;
    });
};
